import type { NskResponse } from "~/models/Api";
import type { WorkflowResourceType } from "~/models/CompanyWorkflowSetting";
import { putRequest } from "~/utils/api/api_handler";
import { generatePath } from "~/utils/generatePath";

export const unlock = async (
	dealId: number,
	resourceType: WorkflowResourceType
): Promise<NskResponse> =>
	putRequest(
		generatePath(
			"/deals/:deal_id/deal_construction_workflow_locks/:resource_type/unlock",
			{ deal_id: dealId, resource_type: resourceType }
		)
	);
